import { SAMPLE_SHIPMENT } from "../constants";

const initialState = {
    sampleShipment: null,
    sampleShipments: [],
    isLoadingSampleShipments: false,
    createdSampleShipment: false,
    updatedSampleShipment: false,
    isLoadingSampleShipment: false,
    error: null,
    };
const sampleShipmentReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case SAMPLE_SHIPMENT.SAMPLE_SHIPMENT_GET_ALL:
            return {
                ...state,
                isLoadingSampleShipments: true,
                error: null,
            };
        case SAMPLE_SHIPMENT.SAMPLE_SHIPMENT_GET_ALL_FAILURE:
            return {
                ...state,
                isLoadingSampleShipments: false,
                error: action.payload,
            };
        case SAMPLE_SHIPMENT.SAMPLE_SHIPMENT_GET_ALL_SUCCESS:
            return {
                ...state,
                isLoadingSampleShipments: false,
                sampleShipments: action.payload,
                error: null,
            };
        case SAMPLE_SHIPMENT.SAMPLE_SHIPMENT_CREATE:
            return {
                ...state,
                createdSampleShipment: false,
                isLoadingSampleShipment: true,
            };
        case SAMPLE_SHIPMENT.SAMPLE_SHIPMENT_CREATE_FAILURE:
            return {
                ...state,
                isLoadingSampleShipment: false,
                error: action.payload,
            };
        case SAMPLE_SHIPMENT.SAMPLE_SHIPMENT_CREATE_SUCCESS:
            return {
                ...state,
                createdSampleShipment: true,
                isLoadingSampleShipment: false,
                sampleShipment: action.payload,
                error: null,
            };
        case SAMPLE_SHIPMENT.SAMPLE_SHIPMENT_UPDATE:
            return {
                ...state,
                updatedSampleShipment: false,
                isLoadingSampleShipment: true,
            };
        case SAMPLE_SHIPMENT.SAMPLE_SHIPMENT_UPDATE_FAILURE:
            return {
                ...state,
                isLoadingSampleShipment: false,
                error: action.payload,
            };
        case SAMPLE_SHIPMENT.SAMPLE_SHIPMENT_UPDATE_SUCCESS:
            return {
                ...state,
                updatedSampleShipment: true,
                isLoadingSampleShipment: false,
                sampleShipment: action.payload,
                error: null,
            };
        case SAMPLE_SHIPMENT.SAMPLE_SHIPMENT_GET_ONE:
            return {
                ...state,
                isLoadingSampleShipment: true,
                sampleShipment: null,
                error: null,
            };
        case SAMPLE_SHIPMENT.SAMPLE_SHIPMENT_GET_ONE_FAILURE:
            return {
                ...state,
                isLoadingSampleShipment: false,
                error: action.payload,
            };
        case SAMPLE_SHIPMENT.SAMPLE_SHIPMENT_GET_ONE_SUCCESS:
            return {
                ...state,
                isLoadingSampleShipment: false,
                sampleShipment: action.payload,
                error: null,
            };
        default:
            return state;
    }
}
export default sampleShipmentReducer;
